var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"images"},[_c('ul',[_c('viewer',{ref:"viewer",attrs:{"images":_vm.imgUrlList},on:{"inited":_vm.inited}},_vm._l((_vm.imgUrlList),function(value,index){return _c('li',{key:index},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":value.path,"alt":"图片"}})]),_c('span',{},[_vm._v(_vm._s(value.title))])])}),0)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }